import React from 'react';
import { useForm } from 'react-hook-form';
import CrudCreate from '~/components/CrudCreate';
import IVehicleColor from '../interfaces/IVehicleColor';
import Layout from '~/components/Layout';

export default function Create() {     
  const {register, handleSubmit, control, setValue:setFormValue} = useForm<IVehicleColor>();
  const fields = [
      { name: 'name', type: 'string'},
  ];
  
    return(
      <Layout marginLayout={true}>
        <CrudCreate model={'vehicle-color'} 
        fields={fields} 
        register={register} 
        handleSubmit={handleSubmit} 
        control={control} 
        messageSuccess={'Vehicle color successfully created!'}  
        title={'Add vehicle color'}  
        subheader={'Add vehicle color'}
        setFormValue={setFormValue} />
      </Layout>
    )
}
